// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__Hy20k","notes":"Notes_notes__YLavv","note":"Notes_note__NiKqG","markdown":"Notes_markdown__1fHDC"};